import { FaIcon } from '@ifixit/ui/components/icon';
import { _js } from '@ifixit/utils/localize';
import { cn } from '@ifixit/ui/lib/utils';
import type { ReactElement, ReactNode } from 'react';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapButton, tiptapButtonClassName } from '../components/TiptapButton';
import { TiptapMenubar } from '../components/TiptapMenubar';

const noop = () => {};

const DisabledButton = ({ icon, title }: { icon: ReactElement<any>; title: string }) => (
   <TiptapButton isDisabled onClick={noop} icon={icon} title={title} />
);

/**
 * Static twin of GuideIntroMenuBar for wikitext source mode, where no Tiptap
 * editor exists (source mode never mounts Tiptap so unparseable documents
 * can't crash the page, and the live buttons need an editor instance to
 * render). Keep the controls in sync with GuideIntroMenuBar — this file
 * stays free of Tiptap imports so it can ship in the eager bundle.
 */
export const GuideIntroMenuBarDisabled = ({ menubarEnd }: { menubarEnd?: ReactNode }) => (
   <TiptapMenubar menubarEnd={menubarEnd}>
      <DisabledButton icon={<FaIcon name="bold" />} title={_js('Bold')} />
      <DisabledButton icon={<FaIcon name="italic" />} title={_js('Italic')} />
      <DisabledButton icon={<FaIcon name="code" />} title={_js('Insert code')} />
      <DisabledButton icon={<FaIcon name="link" />} title={_js('Insert a link')} />
      <MenuSeparator />
      <button
         type="button"
         disabled
         aria-label={_js('Text style')}
         className={cn(tiptapButtonClassName, 'p-1')}
      >
         <span className="inline-flex items-center gap-[7px]">
            <FaIcon name="paragraph" />
            <FaIcon name="chevron-down" />
         </span>
      </button>
      <MenuSeparator />
      <DisabledButton icon={<FaIcon name="list-ul" />} title={_js('Add a bulleted list')} />
      <DisabledButton icon={<FaIcon name="list-ol" />} title={_js('Add a numbered list')} />
      <DisabledButton icon={<FaIcon name="outdent" />} title={_js('Decrease indent')} />
      <DisabledButton icon={<FaIcon name="indent" />} title={_js('Increase indent')} />
      <MenuSeparator />
      <DisabledButton
         icon={<FaIcon name="video" />}
         title={_js('Insert a YouTube or Vimeo Video')}
      />
      <MenuSeparator />
      <DisabledButton icon={<FaIcon name="arrow-rotate-left" />} title={_js('Undo')} />
      <DisabledButton icon={<FaIcon name="arrow-rotate-right" />} title={_js('Redo')} />
   </TiptapMenubar>
);
